/* CAUTION, THIS FILE IS AUTO-GENERATED */
/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import { withIconFlavour } from '../withIconFlavour';

const IconMessageReplyAll = ({ size = 16, className = '', ...props }) => (
  <svg
    {...props}
    className={className}
    width={size}
    height={size}
    viewBox="0 0 16 16"
  >
    <path
      fill="currentColor"
      d="M5.345 3.852a.5.5 0 0 0-.706-.708l-4 3.994a.501.501 0 0 0-.001.707l4 4.007a.502.502 0 0 0 .707 0 .5.5 0 0 0 .001-.708L1.699 7.491l3.646-3.639zm10.163 9.646a.522.522 0 0 0-.021-.144c-.091-5.012-4.883-8.227-8.306-8.34l1.164-1.162a.5.5 0 0 0-.706-.708l-4 3.994a.501.501 0 0 0-.001.707l4 4.007a.502.502 0 0 0 .707 0 .5.5 0 0 0 .001-.708L7.202 9.998c3.536.047 5.946 1.271 7.36 3.746.09.157.256.249.43.249h.012c.258-.016.504-.219.504-.495z"
    />
  </svg>
);

IconMessageReplyAll.displayName = 'IconMessageReplyAll';

IconMessageReplyAll.propTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
};

export default withIconFlavour(IconMessageReplyAll);
IconMessageReplyAll.displayName = 'IconMessageReplyAll';
